import { useEffect, useRef } from 'react'
import NoSleep from 'nosleep.js'

export function useScreenWake() {
  const noSleep = useRef<NoSleep>()
  useEffect(() => {
    noSleep.current = new NoSleep()
    function enableNoSleep() {
      document.removeEventListener('touchstart', enableNoSleep, false)
      noSleep.current?.enable()
    }
    // Must be wrapped in a user input event to work
    document.addEventListener('touchstart', enableNoSleep, false)
    return () => {
      noSleep.current?.disable()
    }
  }, [])
}
